/**
 * @date: 2023-05-10
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */
import React from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {Alert, IconButton} from "@mui/material";
import FHIRDetailsTable from "./FHIRDetailsTable";
import CloseIcon from "@mui/icons-material/Close";
import {useSelector} from "react-redux";

export default function CurrentDirectoryFHIRInformationDialog(props) {
    const {
        fhirInfoDialogOpen,
        setFhirInfoDialogOpen
    } = props;

    const {fhirInformationDetails} = useSelector(state => state.currentDirectFhirInformation);

    const handleClose = () => {
        setFhirInfoDialogOpen(false);
    }

    return (
        <Dialog
            open={fhirInfoDialogOpen}
            onClose={handleClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
            sx={{ '& .MuiDialog-paper': { minWidth: 800, minHeight: 300, maxHeight: 600 } }}
        >
            <DialogTitle id="dialog-title" sx={{ '&.MuiDialogTitle-root': { paddingBottom: 0 }}}>
                {"Current Directory FHIR Information Detail"}
                <IconButton sx={{ float: 'right' }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {fhirInformationDetails &&
                    <div>
                        <FHIRDetailsTable details={fhirInformationDetails} />
                    </div>
                }
                {!fhirInformationDetails && <Alert severity={'info'}>No details found</Alert>}
            </DialogContent>
        </Dialog>

    )
}